export default "__VITE_ASSET__kwTEpb_a__"